module.exports = __webpack_public_path__ + "node_modules/icheck/skins/flat/blue.png?36ae7b1e";